/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type BookmarksWidgetContainer_user$ref = any;
type ClockWidgetContainer_user$ref = any;
type NotesWidgetContainer_user$ref = any;
type SearchWidgetContainer_user$ref = any;
type TodosWidgetContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type WidgetContainer_user$ref: FragmentReference;
declare export opaque type WidgetContainer_user$fragmentType: WidgetContainer_user$ref;
export type WidgetContainer_user = {|
  +$fragmentRefs: BookmarksWidgetContainer_user$ref & SearchWidgetContainer_user$ref & ClockWidgetContainer_user$ref & NotesWidgetContainer_user$ref & TodosWidgetContainer_user$ref,
  +$refType: WidgetContainer_user$ref,
|};
export type WidgetContainer_user$data = WidgetContainer_user;
export type WidgetContainer_user$key = {
  +$data?: WidgetContainer_user$data,
  +$fragmentRefs: WidgetContainer_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "WidgetContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BookmarksWidgetContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SearchWidgetContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ClockWidgetContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "NotesWidgetContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TodosWidgetContainer_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '72463cb7c70533dabda1b64cdafc8624';
module.exports = node;
